// extracted by mini-css-extract-plugin
export default {"btn-icon":"btn-icon__9EyQY","subscription-dropdown-item":"subscription-dropdown-item__2Ysk-","head":"head__3N3AM","item-icon":"item-icon__wDfob","text":"text__1ZBgz"};